

































































import { Component, Prop } from "vue-property-decorator";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { date, dateTime, timeFromNow } from "@/shared/filters";
import {
  AtendimentoService,
  RegistrarAtendimento,
  StatusChamada,
} from "@/services/atendimento.service";
import ComboMotivoFechamento from "../ComboMotivoFechamento.vue";
import { validHora, required } from "@/shared/validators";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";

@Component({
  components: {
    ComboMotivoFechamento,
    DatePickerCalendar,
  },
  filters: { date, dateTime, timeFromNow },
})
export default class RegistrarChamadas extends mixins(GlobalMixin) {
  @Prop() idAtendimento!: number;
  @Prop({ default: null }) readonly atendimento!: any | null;

  tipoAssinatura: string | null = "";
  meioPagamento: string | null = "";
  loading = false;
  showSucess = false;
  showError = false;
  msgSucess: string | null = "";

  validacao = [required()];

  campos = {
    campo1: true,
    campo2: false,
  };

  chamada: RegistrarAtendimento = {
    idAtendimento: Number(this.$route.params.idAtendimento),
    status: 1,
    idMotivoFechamentoAtendimento: null,
    data: "",
    hora: "",
    observacao: "",
  };

  rules = {
    data: [required()],
    hora: [validHora()],
    motivo: [required()],
    observacao: [required()],
  };

  acaoItems = [
    { text: "Reagendar", value: StatusChamada["Reagendar"] },
    { text: "Sem contato", value: StatusChamada["SemContato"] },
    { text: "Fechar atendimento", value: StatusChamada["FecharAtendimento"] },
  ];

  async registrarChamada() {
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.startLoader();
      await AtendimentoService.RegistrarChamada(this.chamada).finally(
        this.stopLoader
      );
      this.msgSucess = "Chamada registrada com sucesso!";
      this.showSucess = true;
      this.$router.back();
      setTimeout(this.fechaAlertaStatus, 5000);
    }
  }

  fechaAlertaStatus() {
    this.showSucess = false;
    this.showError = false;
  }

  changedStatus() {
    switch (this.chamada.status) {
      case 1:
        this.campos.campo1 = true;
        this.campos.campo2 = false;
        break;
      case 2:
        this.campos.campo1 = false;
        this.campos.campo2 = false;
        break;
      case 9:
        this.campos.campo1 = false;
        this.campos.campo2 = true;
        break;
      default:
        this.campos.campo1 = false;
        this.campos.campo2 = false;
        break;
    }
  }
}
